// ページ内アンカーリンクのスクロールエフェクト // Scrolling effect for anchor links within the page
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定) // Set header height to headerHight if header is fixed (PC/SP setting required)
jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})


// ページトップボタンの表示 // Display the page top button
jQuery(function($) {
	if ( $('#pageup').length > 0 ) {
		var topBtn = $('#pageup');
		topBtn.css("display", "none");
		//スクロールが100に達したらボタン表示 // display button when scroll reaches 100
		$(window).scroll(function () {
			if ($(this).scrollTop() > 100) {
				topBtn.fadeIn();
			} else {
				topBtn.fadeOut();
			}
		});
		//スクロールしてトップ // scroll to the top
		topBtn.click(function () {
			$('body,html').animate({
				scrollTop: 0
			}, 500);
			return false;
		});
	}
});

//show fixedBar
jQuery(function($) {
	var fixedBar = $('.js-fixedBar');
	fixedBar.css("display", "none");
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			fixedBar.fadeIn();
		} else {
			fixedBar.fadeOut();
		}
	});
});

// ヘッダーの固定エフェクト // Fixed header effect
// jQuery(function($) {
// 	var $header = $('header');
// 	$(window).scroll(function() {
// 		if ($(window).scrollTop() > 50) {
// 			$header.addClass('fixed');
// 		} else {
// 			$header.removeClass('fixed');
// 		}
// 	});
// });


// アコーディオンの起動 // Activate the accordion
jQuery(function($) {
  if ($('.js-toggle .js-toggleHead').length > 0) {
    $(".js-toggle .js-toggleHead").click(function() {

		var $this = $(this);
		var $toggleWrap = $this.next(".js-toggleWrap");

		if($this.hasClass('open')){
			$toggleWrap.slideUp();
			$this.removeClass("open");
		} else {
			$toggleWrap.slideToggle();
			$this.toggleClass("open");
		}
    });
  }
});

jQuery(function($) {
	if ($('dl.accordion dt').length > 0) {
		$("dl.accordion dt").click(function(){
			$("dl.accordion dd").not($(this).next("dd")).slideUp();
			$("dl.accordion dt").not($(this)).removeClass("open");

			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});

//  matchHeight
jQuery(function($) {
    var t = 0;
    if ($('.js-matchHeight').length) {
        $(window).on('load resize', function() {
            $('.js-matchHeight').css('height', 'auto');
            if ($(window).width() > 767) {
                $('.js-matchHeight').stop().each(function() {
                    if ($(this).outerHeight() > t) {
                        highest = t = $(this).outerHeight();
                    }
                });
                $('.js-matchHeight').css('height', highest + 'px');
            }
        });
    }
})

//  Scrollable
jQuery(function($) {
	if ($('.js-scrollable').length) {
		$(window).on('load resize', function() {
			if ($(window).width() < 767) {
				new ScrollHint('.js-scrollable', {
					applyToParents: true,
					i18n: {
						scrollable: 'スクロールできます'
					}
				});
			}
		})
	}
});

function CountdownTimer(elm, tl, mes) {
  this.initialize.apply(this, arguments);
}
CountdownTimer.prototype = {
  initialize: function (elm, tl, mes) {
    this.elem = document.getElementById(elm);
    this.tl = tl;
    this.mes = mes;
  },
  countDown: function () {
    var timer = '';
    var today = new Date();
    var remainingTime = this.tl - today;

    if (remainingTime > 0) {
      var day = Math.floor(remainingTime / (24 * 60 * 60 * 1000));
      var hour = Math.floor((remainingTime % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
      var min = Math.floor((remainingTime % (60 * 60 * 1000)) / (60 * 1000));
      var sec = Math.floor((remainingTime % (60 * 1000)) / 1000);

      if (day > 0) timer += `<span class="cdt_num">${day}</span><small>日と</small>`;
      if (hour > 0 || day > 0) timer += `<span class="cdt_num">${hour}</span><small>時間</small>`;
      timer += `<span class="cdt_num">${this.addZero(min)}</span><small>分</small>`;
      timer += `<span class="cdt_num">${this.addZero(sec)}</span><small>秒</small>`;

      this.elem.innerHTML = timer;

      // 再帰的に次の更新を設定
      var me = this;
      setTimeout(function () {
        me.countDown();
      }, 1000);
    } else {
      // カウントダウン終了後のメッセージ
      this.elem.innerHTML = this.mes;
    }
  },
  addZero: function (num) {
    return ('0' + num).slice(-2);
  }
};

// タイマーのセットアップ関数
function setupCountdownTimer(elmId, txtId, start, end) {
  var now = new Date().getTime(); // 現在時刻
  var startDate = new Date(start).getTime();
  var endDate = new Date(end).getTime();
  var text = '';
  var targetDate;

  // 日付に応じた表示設定
  if (startDate <= now && endDate >= now) {
    text = '<span>終了</span><span>まで</span>';
    targetDate = new Date(end);
  } else if (startDate > now) {
    text = '<span>開催</span><span>まで</span>';
    targetDate = new Date(start);
  } else {
    text = '<small>終了しました</small>';
    targetDate = null;
  }

  // カウントダウンタイマーのインスタンスを作成
  if (targetDate) {
    var timer = new CountdownTimer(elmId, targetDate, '<small>終了しました</small>');
    timer.countDown();
  }

  // テキスト部分の更新
  if (document.getElementById(txtId)) {
    document.getElementById(txtId).innerHTML = text;
  }
}

// window.onload = function () {
//   // 1つ目のタイマー
//   // setupCountdownTimer(
//   //   'cdt_date1', // タイマー表示部分のID
//   //   'cdt_txt1',  // テキスト表示部分のID
//   //   '2025-02-28T09:00+09:00', // 開始日時
//   //   '2025-03-17T17:00+09:00'  // 終了日時
//   // );

//   // 2つ目のタイマー
//   setupCountdownTimer(
//     'cdt_date2', // タイマー表示部分のID
//     'cdt_txt2',  // テキスト表示部分のID
//     '2025-03-17T00:00+09:00', // 開始日時
//     '2025-03-31T17:00+09:00'  // 終了日時
//   );
// }
